module.exports = ".yes-btn{background-color:#116CAE;color:#FCFCFC}.no-btn{background-color:#A1A1A1;color:#000}\n"